import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import {useLocation} from "react-router-dom";

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export const useAppLocation = () => useLocation()
